<body>
    <div class="title">
        <span class="font">FILTER</span>
        <span style="cursor: pointer;" (click)="closeDilaog('')">X</span>
    </div>
    <div class="los">
        <label> State </label>
        <mat-select id="lostypes" class="flex-center" placeholder="Select State" [(ngModel)]="selectedState">
            <input matInput [matAutocomplete]="stateOptionsauto" [formControl]="stateFilter"
                class="input inputborderpopup" placeholder="Enter State Name">
            <mat-autocomplete #stateOptionsauto="matAutocomplete"></mat-autocomplete>
            <mat-option *ngFor="let item of stateOptions | async" [value]="item" (click)="getZones(item)">{{item.stateName}}</mat-option>
        </mat-select>
    </div>

    <div class="los">
        <label> Zone </label>
        <mat-select id="lostypes" class="flex-center" placeholder="Select Zone" [(ngModel)]="selectedZone">
            <input matInput [matAutocomplete]="zoneOptionsauto" [formControl]="zoneFilter"
                class="input inputborderpopup" placeholder=" Enter Zone Name">
            <mat-autocomplete #zoneOptionsauto="matAutocomplete"></mat-autocomplete>
            <mat-option *ngFor="let item of zoneOptions | async" [value]="item" (click)="getCitites(item)">{{item.zoneName}}</mat-option>
        </mat-select>
    </div>

    <div class="los">
        <label> City</label>
        <mat-select id="lostypes" class="flex-center" placeholder="Select City" [(ngModel)]="selectedCity">
            <input matInput [matAutocomplete]="cityOptionsauto" [formControl]="cityFilter"
                class="input inputborderpopup" placeholder=" Enter City Name">
            <mat-autocomplete #cityOptionsauto="matAutocomplete"></mat-autocomplete>
            <mat-option *ngFor="let item of cityOptions | async" [value]="item" (click)="getCampus(item)">{{item.cityName}}</mat-option>
        </mat-select>
    </div>
    <div class="los">
        <label> Campus</label>
        <mat-select id="lostypes" class="flex-center" placeholder="Select Campus" [(ngModel)]="selectedCampus">
            <input matInput [matAutocomplete]="campusOptionsauto" [formControl]="campusFilter"
                class="input inputborderpopup" placeholder="Enter Campus Name ">
            <mat-autocomplete #campusOptionsauto="matAutocomplete"></mat-autocomplete>
            <mat-option *ngFor="let item of campusOptions | async" [value]="item" (click)="selectCampus(item)" >{{item.campusName}}</mat-option>
        </mat-select>
    </div>
    <div
        style="width: 100%; height: 40px; display:flex; justify-content: center; align-items: center;position: absolute;bottom: 100px;">
        <button class="button"  (click)="closeDilaog('search')">Search</button>
    </div>
</body>